// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
import { getAuth } from 'firebase/auth';
import i18n from './localization/i18n';

const firebaseConfig = (window as any).firebaseConfig;

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);

const auth = getAuth(app);

// Keep Firebase's own SMS (Phone Auth login codes) in the user's selected language.
auth.languageCode = i18n.language;
i18n.on('languageChanged', (lng) => {
  auth.languageCode = lng;
});

export { auth }